import { motion } from 'framer-motion'
import styled, { createGlobalStyle } from 'styled-components/macro'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const CssVars = createGlobalStyle`
  :root {
    --nav-width: 0rem;
    --nav-margin: 0rem;

    ${mq.medium} {
      --nav-width: 0.5rem;
      --nav-margin: 0rem;
    }

    ${mq.large} {
      --nav-width: 20rem;
      --nav-margin: 6rem;
    }
  }
`

export const StyledNav = styled.div`
  font-size: 1.8rem;

  ${mq.medium} {
    position: absolute;
    height: 100%;
    width: var(--nav-width);
  }

  ${mq.mediumOnly} {
    margin-left: calc(var(--container-spacing) * -0.5);
  }

  button {
    ${styleReset}
    max-width: 100%;

    ${mq.medium} {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &:not(:disabled) {
      cursor: pointer;
    }

    &:disabled {
      font-weight: 800;
      color: ${theme.colors.accent.rfe};
    }
  }

  > div {
    ${mq.medium} {
      position: sticky;
      top: var(--header-height);
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: calc(100vh - var(--header-height));
      overflow: auto;
      z-index: 100;
    }
  }

  ul {
    list-style: none;
    padding: 0;
  }
`

export const ChaptersList = styled(motion.ul)`
  li {
    --padding: 1rem;

    display: block;
    position: relative;
    padding: var(--padding) 0;

    &:not(:first-child) {
      border-top: 1px dotted #5b677080;
    }

    ${mq.mediumOnly} {
      --padding: 0.2rem;

      font-size: 0;
      border-top: none !important;

      button::before {
        content: '';
        display: block;
        width: 0.4rem;
        height: 1.8rem;
        border-radius: 3px;
        background-color: currentColor;
      }
    }
  }

  > li {
    padding-right: 3rem;

    ${mq.mediumOnly} {
      padding-right: 0;
    }
  }
`

export const SectionsList = styled(motion.ul)`
  margin: 0.4rem -2rem 0 2rem;
  font-size: 1.6rem;
  overflow: hidden;

  ${mq.mediumOnly} {
    margin-left: 0;

    button::before {
      height: 0.8rem !important;
      opacity: 0.3;
    }
  }

  button:disabled {
    color: inherit;
    font-weight: bold;
  }

  li[data-hidden] {
    display: none;
  }
`

export const Number = styled.span`
  position: absolute;
  display: block;
  top: var(--padding);
  right: 0;
  width: 2.4rem;
  height: 2.4rem;
  margin-top: -0.1rem;
  text-align: center;
  font-weight: normal;
  border-radius: 0.4rem;
  border: 1px solid currentColor;

  button:disabled & {
    border-color: transparent;
    color: white;
    background-color: ${theme.colors.accent.rfe};
  }

  ${mq.mediumOnly} {
    display: none;
  }

  ${mq.large} {
    margin-top: -0.3rem;
  }
`
